import React from "react";
import { Store, Briefcase, CalendarCheck } from "lucide-react";

export default function UseCases() {
  const items = [
    {
      title: "Small Retailers",
      desc: "Accept crypto at the counter with QR payments. Fast, low fees, no chargebacks.",
      Icon: Store,
    },
    {
      title: "Freelancers",
      desc: "Invoice clients with a QR and get paid in SOL, USDC, or EURC in seconds.",
      Icon: Briefcase,
    },
    {
      title: "Events & Pop‑ups",
      desc: "Set up a portable POS in minutes. No hardware beyond your phone.",
      Icon: CalendarCheck,
    },
  ];

  return (
    <section id="use-cases" className="relative overflow-hidden" data-reveal>
      <div className="mx-auto max-w-6xl px-4 py-16 relative">
        <h2 className="mb-6 text-center text-3xl font-semibold">Use Cases</h2>
        <p className="mx-auto mb-10 max-w-2xl text-center text-neutral-300">
          Payme.sol makes it easy to accept crypto payments across different scenarios.
        </p>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
          {items.map(({ title, desc, Icon }, idx) => (
            <div
              key={title}
              data-reveal
              style={{ ['--reveal-delay' as any]: `${idx * 90}ms` }}
              className="rounded-lg border border-neutral-700 bg-neutral-900/40 p-6 text-center transition-all duration-300 hover:border-indigo-500/50 hover:bg-indigo-500/5 hover:shadow-[0_0_34px_rgba(99,102,241,0.12)] hover:-translate-y-0.5"
            >
              <div className="mb-3 inline-flex items-center justify-center rounded-md bg-indigo-600/15 p-2">
                <Icon className="size-5 text-indigo-400" />
              </div>
              <h3 className="text-lg font-semibold text-white">{title}</h3>
              <p className="mt-3 text-neutral-300">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
